/* Heirloom cart merchandising: pack upgrade swap. */
(() => {
  if (window.__emCartMerch) return;
  window.__emCartMerch = true;

  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  const sectionIds = () =>
    Array.from(document.querySelectorAll('cart-items-component'))
      .map((el) => el.dataset.sectionId)
      .filter(Boolean);

  const announce = (cart, sections) => {
    document.dispatchEvent(
      new CustomEvent('cart:update', {
        bubbles: true,
        detail: { resource: cart, sourceId: 'em-cart-merch', data: { itemCount: cart.item_count, source: 'em-cart-merch', sections } },
      })
    );
  };

  // 1) One-tap pack upgrade: add the pack (tagged _em_source=cart_upgrade), remove the Single, re-render.
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-em-upgrade]');
    if (!button || button.disabled) return;
    event.preventDefault();
    button.disabled = true;
    button.classList.add('is-loading');
    try {
      const ids = sectionIds();
      // Add the pack (tagged for attribution), then remove the Single line and re-render the cart sections.
      const add = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(button.dataset.targetId), quantity: 1, properties: { _em_source: 'cart_upgrade' } }] }),
      });
      const added = await add.json();
      if (!add.ok || added.status) throw new Error(added.description || 'Upgrade failed');
      const response = await fetch(`${root}cart/change.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: button.dataset.lineKey, quantity: 0, sections: ids.join(','), sections_url: window.location.pathname }),
      });
      const cart = await response.json();
      if (!response.ok || cart.status) throw new Error(cart.description || 'Upgrade failed');
      announce(cart, cart.sections || {});
    } catch (error) {
      console.error(error);
      button.disabled = false;
      button.classList.remove('is-loading');
    }
  });

})();
